// extracted by mini-css-extract-plugin
export default {"wrapper":"Xm-z","response":"Ym-z","error":"Zm-z","disabled":"_m-z","buttons":"an-z","feedbackQuestionSection":"bn-z","yesNoWrapper":"cn-z"};